import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { DatePipe } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-superadmin-export',
  templateUrl: './superadmin-export.component.html',
  styleUrls: ['./superadmin-export.component.scss']
})
export class SuperadminExportComponent implements OnInit {
  @Input() public Content: any;
  MonoWindowPDF: UntypedFormGroup
  public content: any;
  log_data: any[] = [];
  details_data: any;
  category: string;
  src: string;
  orgCode: string;
  now = new Date();
  Datestring: string;
  constructor(public modalRef: NgbActiveModal, private userService: UserService, public datepipe: DatePipe) {
    this.src = "../../../assets/images/logo1.png";
  }

  ngOnInit(): void {

    this.category = "";
    this.orgCode = "";
    this.Datestring = this.datepipe.transform(this.now.toUTCString(), 'dd-MMM-YYYY HH:mm:ss');
    if (this.Content.content.log_data != null && (this.Content.content.log_data.length == 1 || this.Content.content.log_data.length > 1)) {
      this.log_data = this.Content.content.log_data;
    }
    else {
      this.log_data.push(this.Content.content.log_data);
    }
    this.details_data = this.Content.content.details_data;
    this.category = this.Content.content.cat_type;
    this.userService.getLogo(this.orgCode).subscribe(result => {
      if (result === null || result === undefined || result === '') {
        this.src = "../../../assets/images/logo1.png";
      }
      else {
        if (result.FileExt == 'svg') {
          this.src = 'data:image/svg+xml;base64,' + result.Image;
        }
        else {
          this.src = 'data:image/png;base64,' + result.Image;
        }
      }
    });
  }



  closePopup() {
    this.modalRef.dismiss();
  }
}
